var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.fileUrl)?_c('img',{staticClass:"rounded mb-3",staticStyle:{"width":"90px"},attrs:{"src":_vm.fileUrl}}):_vm._e(),_vm._v(" "),_c('input',{ref:"file",staticClass:"w-100",attrs:{"type":"file","id":"file","accept":"image/*"},on:{"change":_vm.compressFile}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c3bb01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SavImageInput.vue
// module id = null
// module chunks = 